// Our main CSS
import '../css/app.css'
import { createApp } from 'vue'

/**
 * Vue is ready for you, if you need it.
 */

import { ModuleManager } from './moduleManager'


// Create and configure module manager
const moduleManager = new ModuleManager()

// Register all modules with their selectors
moduleManager
  .register('.js-expandable-sections', 'expandableSections')
  .register('.js-customer-slider', 'customerSlider')
  .register('.js-employee-quote-slider', 'employeeQuoteSlider')
  .register('.js-history-slider', 'historySlider')
  .register('.js-product-slider', 'productSlider')
  .register('.js-expandable-footer', 'expandableFooterSections')
  .register('.js-video-player', 'videoPlayer')
  .register('.js-office-list', 'officeList')
  .register('.js-temporary-product-archive', 'temporaryProductArchive')
  .register('.js-permanent-product-archive', 'permanentProductArchive')
  .register('.archive-cases', 'archiveCasesFilters')
  .register('.js-accessory-slider', 'accessorySlider')

  .registerAdmin('ExpandableSections', 'expandableSections')
  .registerAdmin('CustomerSlider', 'customerSlider')
  .registerAdmin('EmployeeQuoteSlider', 'employeeQuoteSlider')
  .registerAdmin('HistorySlider', 'historySlider')
  .registerAdmin('ProductSlider', 'productSlider')
  .registerAdmin('VideoPlayer', 'videoPlayer')
  .registerAdmin('OfficeList', 'officeList')
  .registerAdmin('TemporaryProductArchive', 'temporaryProductArchive')
  .registerAdmin('PermanentProductArchive', 'permanentProductArchive')
  .registerAdmin('ArchiveCases', 'archiveCasesFilters')
  .registerAdmin('AccessorySlider', 'accessorySlider')

// Initialize modules
moduleManager.init()

let menu = document.getElementById('js-vue-menu')
const menuApp = createApp({
  data() {
    return {
      active: false,
      activeChildren: false,
      searchActive: false,
      mobileMenuActive: false,
      languageDropdownActive: false
    }
  },
  methods: {
    showSubMenu(subMenu) {
      this.active = subMenu
    },
    showSubMenuResetChildren(subMenu) {
      this.active = subMenu
      this.activeChildren = false
    },
    showChildMenu(childMenu) {
      this.activeChildren = childMenu
    },
    toggleSearch() {
      this.searchActive = !this.searchActive
    },
    toggleMobileMenu() {
      this.mobileMenuActive = !this.mobileMenuActive
      document.body.classList.toggle('overflow-hidden', this.mobileMenuActive)
    },
    resetSubMenu() {
      this.active = false,
      this.activeChildren = false
    },
    resetChildMenu() {
      this.activeChildren = false
    },
    toggleLanguageDropdown() {
      this.languageDropdownActive = !this.languageDropdownActive
    }
  }
})
menuApp.mount(menu)